export const HIDE_RESULTS = 'hideResults'
export const VIDEO_MODULE = 'video'
export const VIDEO_MODULE_SECOND = 'videoSecond'
export const OVERVIEW_REPORT_MODULE = 'overviewReport'
